import { Injectable } from '@angular/core';
import { State, Store } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { TranslationPackageLanguageBranch } from '@portal-core/translation-package-language-branches/models/translation-package-language-branch.model';

@CollectionStateSelectors({
  stateType: TranslationPackageLanguageBranchesState
})

@State<TranslationPackageLanguageBranchesState>({
  name: TranslationPackageLanguageBranchesState.source
})

@Injectable()
export class TranslationPackageLanguageBranchesState extends CollectionStateBase {
  static source: string = 'TranslationPackageLanguageBranches';
  getSource(): string {
    return TranslationPackageLanguageBranchesState.source;
  }
}

@Injectable({
  providedIn: 'root'
})

export class TranslationPackageLanguageBranchesDataService extends CollectionDataServiceBase<TranslationPackageLanguageBranch> {
  constructor(protected store: Store) {
    super(store, TranslationPackageLanguageBranchesState);
  }
}
